import styled from "styled-components";
export const Box = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }

  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }

  canvas {
    max-width: 100%;
    height: auto;
    display: block;
  }

  .color-input-group {
    display: flex;
    flex-wrap: nowrap;
  }

  .color-text-input {
    height: 44px;
    font-size: 16px;
  }

  .ok-btn {
    flex: 0 0 auto; 
  width: 64px;   
  height: 44px;
  padding: 0;
  background-color: #8cc540;
  border: none;
  font-weight: 600;
  }

  .html5-picker {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .eye-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: 1px solid #ced4da;
    border-radius: 6px;
    background: #fff;
    font-size: 18px;
  }

  .color-picker-input {
    width: 100%;
    height: 44px;
    padding: 0;
    border-radius: 6px;
    border: none;
    cursor: pointer;
  }

  @media (max-width: 576px) {
    .color-text-input {
      font-size: 14px;
    }

    .ok-btn {
      min-width: 40px;
    }
  }
`;
